// extracted by mini-css-extract-plugin
export default {"leaveFeedbackLayout":"leaveFeedbackLayout--3RkUl","loaderContainer":"loaderContainer--7G8pB"};